//import {LabelInterface} from "./Interface";

import {TodoistSync} from "./TodoistSync";
import {
    BuilderInterface,
    Collection,
    EntityTimeInterface,
    FactoryInterface,
    TimeFormat,
    TimeFormatInterface
} from "./Main";
import {TaskInterface} from "./Task";
import {ColorType, ColorTypeSingleton} from "./Color";



export interface LabelInterface {

    getId(): any;

    setColor(color: ColorType): void;
    getColor(): ColorType;

    isDeleted(): number;

    isFavorite(): number;

    getItemOrder(): number;

    getName(): any;

    addTask(task: TaskInterface): void;
    getTasks(): Collection<TaskInterface>;

}

abstract class LabelAbstract implements LabelInterface {

    private label: TodoistSync.LabelInterface;
    private tasks: Collection<TaskInterface>;
    private  colorType: ColorType;

    static isIam: (label: TodoistSync.LabelInterface) => boolean;

    constructor(label: TodoistSync.LabelInterface) {
        this.label = label;
        this.tasks = new Collection();
    }

    getId() {
        return this.label.id;

    }

    setColor(color: ColorType){
        this.colorType = color;
    }

    getColor(): ColorType {
        return this.colorType;
    }

    isDeleted() {
        return this.label.is_deleted;
    }

    isFavorite() {
        return this.label.is_favorite;
    }

    getItemOrder() {
        return this.label.item_order;
    }

    getName() {
        return this.label.name;
    }

    addTask(task: TaskInterface): void {
        this.tasks.addItem(task);
        if(!task.getLabels().isset(this)) {
            task.addLabel(this);
        }
    }

    getTasks(): Collection<TaskInterface>{
        return this.tasks;
    }
}


export class Label extends LabelAbstract {
    static isIam(label: TodoistSync.LabelInterface): boolean {
        return true;
    }
}

export class LabelWork extends LabelAbstract {

    static isIam(label: TodoistSync.LabelInterface) {
        return label.name == 'сф-Работа';
    }
}

export class LabelTime extends LabelAbstract implements EntityTimeInterface{

    private _time: TimeFormat;
    constructor(label: TodoistSync.LabelInterface) {
        super(label);
        this._time  = new TimeFormat(Number(this.getName().replace("min", "")) || 0)
    }

    getTime(): TimeFormatInterface {
        return this._time;
    }

    static isIam(label: TodoistSync.LabelInterface) {
        return label.name.search('[0-9]+min') != -1
    }
}


export class LabelMonth extends LabelAbstract {

}


export class LabelBuilder implements BuilderInterface<TodoistSync.LabelInterface, LabelInterface>{

    private colorTypeCollection: ColorTypeSingleton;
    constructor(){
        this.colorTypeCollection = ColorTypeSingleton.getInstance();
    }

    build(label: TodoistSync.LabelInterface): LabelInterface {
        let labelApp: LabelInterface;
        if (LabelTime.isIam(label)) {
            labelApp =  new LabelTime(label);
        }else if (LabelWork.isIam(label)) {
            labelApp =  new LabelWork(label);
        }
        else {
            labelApp =new Label(label);
        }

        labelApp.setColor(this.colorTypeCollection.getById(label.color))


        return labelApp;
    }

}
